export const chatPrimaryColor = '#5B50FD'
export const chatSuggestionBgColor = '#DCDEF9'
export const chatSuggestionTextColor = '#484848'
export const chatUserBorderColor = '#DDDDDD'
export const chatLinkColor = '#FFE176'
export const chatAvatarColor = '#BCCFDA'
export const chatTextColor = '#222222'

export const chatPrimaryColorBeta = '#DEDFEA'
export const chatSuggestionBgColorBeta = '#D2D5FF'
export const chatLinkColorBeta = '#706100'
export const chatHeaderColorBeta = '#EDF0F6'
